import dynamic from 'next/dynamic';

import { CancellationProps } from './HotelCancellationPolicy.types';

export const HotelCancellationPolicy = dynamic<CancellationProps>(() => import('./HotelCancellationPolicy'));
